/**
 * The pending biography (2.I-2 deliverable 10; DECISIONS 224 ruling 2.I-2-2): **Add Foundry's
 * biography to the page** leaves `{docId, importId}` here and opens the page, whose
 * `FoundryDocTools` takes the entry and applies it in the page's own editor. Module memory only:
 * never browser storage, so a reload forgets it.
 */
import { useSyncExternalStore } from 'react';

export interface PendingBiography {
  readonly docId: string;
  readonly importId: string;
}

const entries = new Map<string, PendingBiography>();
const listeners = new Set<() => void>();
let version = 0;

function changed(): void {
  version++;
  for (const listener of [...listeners]) listener();
}

export function setPendingBiography(entry: PendingBiography): void {
  entries.set(entry.docId, entry);
  changed();
}

/** Removes and returns the entry of a document, once. */
export function takePendingBiography(docId: string): PendingBiography | null {
  const entry = entries.get(docId) ?? null;
  if (entry) {
    entries.delete(docId);
    changed();
  }
  return entry;
}

export function peekPendingBiography(docId: string): PendingBiography | null {
  return entries.get(docId) ?? null;
}

export function usePendingBiography(docId: string): PendingBiography | null {
  useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => version,
  );
  return entries.get(docId) ?? null;
}
